import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";
import { VersionSettings } from "../../pb-screen/static/client/versionSettings";

@Injectable({
  providedIn: "root"
})
export class MergeTranslationService {

  private httpClientService = inject(HttpClient);
  private translateService = inject(TranslateService);

  loadBargeAndCaptainLabels(shouldLoad: boolean, functionToExecute?: Function): void {
    this.loadTranslations(shouldLoad, "barge-and-captain", functionToExecute);
  }

  private loadTranslations(shouldLoad: boolean, url: string, functionToExecute?: Function): void {
    const lang = this.translateService.currentLang ?? this.translateService.defaultLang;

    if (!shouldLoad) {
      this.httpClientService.get(`resources/${lang}.json?v=${VersionSettings.versionNumber}`)
        .subscribe(translations => {
          this.translateService.setTranslation(lang, translations, false);
          if (functionToExecute) {
            functionToExecute();
          }
        });
      return;
    }
    this.httpClientService.get(`resources/${url}-${lang}.json?v=${VersionSettings.versionNumber}`)
      .subscribe(translations => {
        this.translateService.setTranslation(lang, translations, true);
        if (functionToExecute) {
          functionToExecute();
        }
      });
  }
}
